import React from "react";
//Packages
import { Col, Row, Container } from "react-bootstrap";
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
      <div>
          <Container>
            <Row>
              <Col>
                <h1>404: Not Found</h1>
                <p>There&apos;s nothing at this location. If you&apos;ve got an account you can <Link to="/login">login</Link>. Otherwise, go to our <Link to="/">schedule.</Link></p>
              </Col>
            </Row>
          </Container>
      </div>
    );
  }

export default NotFound;